import type { Lang } from "@/hooks/useLang/types";
import ar from "./ar";
import en from "./en";
import type { Translation } from "./types";

const translations: Record<Lang, Translation> = { ar, en };

export default translations;
export type { Translation };
